import axios from "axios";
import commonActions from "../../common.actions";
import getApiUrl from "../../helpers/api-urls";
import { getApiUniqueRequestId } from "../../helpers/util-common";

export const updateBallotStatus: any = (data: any, dispatch: any, callback: (response: any) => void) => {
  dispatch(commonActions.setLoader(true));
  commonActions.ValidateOktaToken((oktaResponse: any) => {
    let url = getApiUrl("openAPI", "updateBallotStatus", true);
    axios
      .put(url, data, { headers: oktaResponse })
      .then((response) => {
        if (!response?.data?.message) {
          dispatch(commonActions.setOverlayLoader(false));
        }
        const uniqueRequestId = getApiUniqueRequestId(url);
        dispatch(commonActions.setLoader(false));
        if (response.data.message) {
          callback(response.data);
        } else {
          dispatch(commonActions.setMessage(true, response.data.message, uniqueRequestId));
          callback({});
        }
      })
      .catch((err) => {
        dispatch(commonActions.setOverlayLoader(false));
        dispatch(commonActions.setLoader(false));
        const uniqueRequestId = getApiUniqueRequestId(url);
        dispatch(commonActions.setMessage(true, "3003", uniqueRequestId));
      });
  })
};

export const ballotRecallToPrePublish: any = (data: any, dispatch: any, callback: (response: any) => void) => {
  dispatch(commonActions.setLoader(true));
  dispatch(commonActions.setOverlayLoader(true));
  commonActions.ValidateOktaToken((oktaResponse: any) => {
    let url = getApiUrl("openAPI", "ballotRecallToPrePublish", true);
    axios
      .put(url, data, { headers: oktaResponse })
      .then((response) => {
        if (!response?.status) {
          dispatch(commonActions.setOverlayLoader(false));
        }
        const uniqueRequestId = getApiUniqueRequestId(url);
        dispatch(commonActions.setLoader(false));
        if (response.status) {
          callback(response);
        } else {
          dispatch(commonActions.setMessage(true, response.data.message, uniqueRequestId));
          callback({});
        }
      })
      .catch((err) => {
        dispatch(commonActions.setLoader(false));
        dispatch(commonActions.setOverlayLoader(false));
        const uniqueRequestId = getApiUniqueRequestId(url);
        dispatch(commonActions.setMessage(true, "3003", uniqueRequestId));
      });
  })
};